import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { helpHttp } from "../../helper/helpHttp";
import * as Styled from "./ExperienciaFleischmann.styled";
import { useDispatch } from "react-redux";
import { changeLoading } from "../../redux/slices/category";
// import { BuildingPage } from "../../components/BuildingPage/BuildingPage";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const fleischmannV2 = {
  36: {
    title: "Panes Especiales",
  },
  38: {
    title: "Panes Enriquecidos",
    evaId: 35,
  },
  39: {
    title: "Matematica Panadera",
    evaId: 36,
  },
};

const fleischmannV2Modulos = {
  37: {
    nombre: "Ingredientes Básicos",
    dependsOn: null,
  },
  38: {
    nombre: "Ingredientes Enriquecidos",
    dependsOn: 37,
  },
  39: {
    nombre: "Matemática Panadera",
    dependsOn: 38,
  },
  40: {
    nombre: "Preparaciones Panes Especiales",
    dependsOn: 39,
  },
};

export const ExperienciaFleischmann = ({
  id = 10,
  v2 = false,
  isVentas = false,
}) => {
  const [data, setData] = useState(undefined);
  const navigate = useNavigate();
  const { get } = helpHttp();
  const dispatch = useDispatch();
  let categoriasURL = "categorias/getSubcategorias";
  if (v2) {
    categoriasURL = "categorias/getSubcategoriasByCategoriaAndUsuario";
  }

  useEffect(() => {
    if (!id) {
      const url = window.location.href;
      id = url.split("/").at(-1);
    }

    dispatch(changeLoading(true));
    get(`${categoriasURL}/${id}`)
      .then((data) => {
        if (v2) {
          data.datos.forEach((e) => {
            if (e.id == 37) {
              e.estado = "habilitado";
              e.navegable = true;
            }

            if (e.id != 37 && fleischmannV2Modulos[e.id]) {
              const dependsOn = fleischmannV2Modulos[e.id]?.dependsOn;
              const dependsOnApproved =
                data.datos.find(({ id }) => id == dependsOn)?.aprobado === 1;
              e.estado = dependsOnApproved ? "habilitado" : "deshabilitado";
              e.navegable = dependsOnApproved ? true : false;
            }
          });
        }
        setData(data.datos);
      })
      .catch(() => toast.error("Ha ocurrido un error"))
      .finally(() => {
        dispatch(changeLoading(false));
      });
  }, [id]);

  const getLinkWithVersioning = (e) => {
    const v2 = fleischmannV2[e.id];
    if (e.navegable === false) {
      return;
    }

    if (v2) {
      if (v2.evaId) {
        navigate(`/main/Expertos%20Fleischmann/${e.id}/${v2.evaId}`);
        return;
      }
      navigate(`/main/Expertos%20Fleischmann/v2/${e.id}`);
      return;
    }

    if (isVentas) {
      navigate(`${e.id}`);
      return;
    }
    navigate(`${e.id}`);
  };

  const getEnableCoursesV2 = (e, data) => {
    if (e.id == "37") {
      return "habilitado";
    }
    if (data[e.id - 1]?.aprobado == "1") {
      return "habilitado";
    }

    return "deshabilitado";
  };

  return (
    <Styled.GridData>
      {data?.length > 0 &&
        data.map((element) => (
          <span
            key={element.id}
            onClick={() => getLinkWithVersioning(element)}
            className="link"
          >
            <Styled.StyledCard
              estado={element.estado}
              key={element.id}
              image={element.icon || "/images/auth__bread.jpg"}
            ></Styled.StyledCard>
          </span>
        ))}
    </Styled.GridData>
  );
};
